<template>
  <template-info :bgImg="bgImg" title="ข้อแตกต่าง">
    <div>
      <div class="title">
        การทำธุรกิจในรูปแบบ “บุคคลธรรมดา” หรือ “นิติบุคคล”
        มีข้อดีข้อด้อยแตกต่างกัน เช่น ถ้าขาดทุน
        บุคคลธรรมดายังต้องเสียภาษีในอัตรา 0.5% ของรายได้
        ในขณะที่ถ้าเป็นนิติบุคคลไม่ต้องเสียภาษี
        นอกจากนี้นิติบุคคลยังสามารถนำค่าใช้จ่ายบาง
        รายการมาหักเป็นรายจ่ายได้มากกว่า 1 เท่า
      </div>
      <div class="wrap-number-li">
        <span> 1. </span>
        <span class="contents">
          แม้ว่า<span class="bold">นิติบุคคล</span
          >จะต้องทำบัญชีตามมาตรฐานบัญชีและนำส่งงบการเงิน แต่หมายความว่าธุรกิจจะ
          เสียภาษีตามผลกำไรที่เกิดขึ้นจริงตามบัญชี ถ้าปีไหนธุรกิจ

          <span class="red bold">"ขาดทุน"</span>
          <span class="bold"> ก็ไม่ต้องเสียภาษี</span>
          (และยังสามารถนำผลขาดทุนไปหักกำไรในปีต่อไป ได้สูงสุดถึง 5 ปี)
          ซึ่งต่างจาก<span class="bold">
            บุคคลธรรมดาที่ ถึงแม้ขาดทุนก็ยังต้องเสียภาษีในอัตรา 0.5%</span
          >ของรายได้(หรือ 1,000 ละ 5)
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 2. </span>
        <span class="contents"
          >นิติบุคคล โดยทั่วไปเสียภาษี 20% ของกำไรสุทธิ (ทางภาษี) เท่านั้น
          ในขณะที่บุคคลธรรมดาเสียภาษี ในอัตราก้าวหน้า ซึ่งอัตราสูงสุดอยู่ที่ 35%
          ทำให้<span class="bold">บุคคลธรรมดาเสียภาษีมากกว่านิติบุคคล</span>
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 3. </span>
        <span class="contents">
          การจดทะเบียนเป็นนิติบุคคลจะทำให้ธุรกิจมีความ
          น่าเชื่อถือมากกว่าธุรกิจในรูปแบบบุคคลธรรมดา
          <span class="bold"
            >ทำให้สถาบันการเงินมีความเชื่อมั่นในการปล่อย สินเชื่อให้ธุรกิจ</span
          >
          ซึ่งเพิ่มโอกาสในการได้รับสินเชื่อ
          ซึ่งหมายถึงโอกาสในการเติบโตของธุรกิจด้วย
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 4. </span>
        <span class="contents">
          การเป็นนิติบุคคลนั้นหมายถึงการแยกระหว่างเงิน
          ของธุรกิจและเงินส่วนตัวของเจ้าของธุรกิจได้อย่างชัดเจน
          ทำให้ไม่สับสนระหว่างเงินทั้งสองส่วน
          ถ้าเป็นบุคคลธรรมดาหากมีการบริหารจัดการไม่ดี
          อาจทำให้ไม่สามารถควบคุมเงินของธุรกิจได้
        </span>
      </div>
      <external-link
        @clickLink="smeJourneyPersonal"
        caption="SME Journey บุคคลธรรมดา"
        class="link-desktop"
        style="margin-top: 30px;"
      />
      <external-link
        @clickLink="smeJourneyCorp"
        caption="SME Journey นิติบุคคล"
        class="link-desktop"
        style="margin: 10px 0;"
      />
      <chevron-right-link
        @clickLink="goChangeProcess"
        :caption="captionLink"
        class="link-desktop"
        style="margin: 10px 0;"
      />
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/pros_cons.png";

export default {
  name: "ProsCons",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
      captionLink: "เปลี่ยนจากบุคคลธรรมดาเป็น\n นิติบุคคลต้องทำอะไรบ้าง",
    };
  },
  methods: {
    goChangeProcess() {
      this.$router.push({ path: "/info/change_process" });
    },
    smeJourneyPersonal() {
      window.open("https://www.rd.go.th/publish/61926.0.html", "_blank");
    },
    smeJourneyCorp() {
      window.open("https://www.rd.go.th/publish/62199.0.html", "_blank");
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
.title {
  margin-bottom: 8px;
}
.wrap-number-li {
  display: flex;
  margin-top: 15px;
}
.wrap-number-li :first-child {
  min-width: 26px;
}
.red {
  color: #f45a49;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .link-desktop {
    white-space: normal !important;
  }
  .title br {
    display: none;
  }
}
</style>
